import { ECOMMERCE_PAGE_COUNT_CONTROL_NAME } from 'editor/src/store/variants/constants';
import { ECommerceProduct } from 'editor/src/store/variants/types';

const normalize = (name: string) => name.toLowerCase().replace(/[\s_-]/g, '');

// The photobook product generator names the option "Page count"; a Store Link variant built from a
// catalogue product can carry the attribute name instead, PagesCount.
const PAGE_COUNT_OPTION_NAMES = [normalize(ECOMMERCE_PAGE_COUNT_CONTROL_NAME), 'pagescount'];

// Index of the option that carries the page count, or -1 when the product has none. An explicit
// `isPageCount` marker from the host wins: option names reach the editor in the shop's locale and
// renamed by merchants, so they only identify the axis for hosts that don't mark it yet.
function getECommercePageCountOptionIndex(ecommerceProduct: ECommerceProduct): number {
  const markedIndex = ecommerceProduct.options.findIndex((option) => option.isPageCount);
  if (markedIndex !== -1) {
    return markedIndex;
  }

  return ecommerceProduct.options.findIndex((option) => PAGE_COUNT_OPTION_NAMES.includes(normalize(option.name)));
}

export default getECommercePageCountOptionIndex;
